<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  height: {
    type: Number,
    default: 300,
  },
});

//#region computed
const computedStyle = computed(() => {
  const result = {};

  if (props.height) {
    result.height = `${props.height}px`;
  }

  return result;
});
//#endregion
</script>

<template>
  <div
    v-show="modelValue"
    v-loading-render="modelValue"
    :style="computedStyle"
    class=" ui-render-loading"
  >
    <slot />
  </div>
</template>

<style lang="scss">
.ui-render-loading {
  opacity: .7;

  &.v-loading::after {
    border: 2px solid var(--v-loading-color);
    animation: 1s linear infinite v-loading;
    border-right-color: transparent;
  }
}
</style>